(function () {
  var STORAGE_KEY = 'toolsVatMode';
  var ROOT = document.documentElement;

  function getSavedMode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || 'inc';
    } catch (error) {
      return 'inc';
    }
  }

  function saveMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // Storage not available. Ignore.
    }
  }

  function applyMode(mode) {
    var safeMode = mode === 'ex' ? 'ex' : 'inc';

    ROOT.classList.remove('tools-vat-mode-inc', 'tools-vat-mode-ex');
    ROOT.classList.add('tools-vat-mode-' + safeMode);
    ROOT.setAttribute('data-tools-vat-mode', safeMode);

    document.querySelectorAll('[data-tools-vat-toggle-input]').forEach(function (toggle) {
      toggle.checked = safeMode === 'ex';
    });

    document.querySelectorAll('[data-tools-vat-toggle]').forEach(function (wrapper) {
      wrapper.setAttribute('data-active-mode', safeMode);
    });
  }

  function bindToggle(toggle) {
    if (toggle.dataset.toolsVatBound === 'true') return;

    toggle.dataset.toolsVatBound = 'true';

    toggle.addEventListener('change', function () {
      var mode = toggle.checked ? 'ex' : 'inc';
      saveMode(mode);
      applyMode(mode);
    });
  }

  function initToolsVatToggle() {
    applyMode(getSavedMode());

    document.querySelectorAll('[data-tools-vat-toggle-input]').forEach(bindToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToolsVatToggle);
  } else {
    initToolsVatToggle();
  }

  document.addEventListener('shopify:section:load', initToolsVatToggle);
})();